/**
 * Single source of truth for the legal entity and public legal documents
 * shown anywhere in the app (auth pages, footers, onboarding).
 *
 * LedgerLoop AB (org.nr 559584-0173) is the provider of the service.
 * The former provider must not be named anywhere in the UI.
 */
export const COMPANY_LEGAL_NAME = 'LedgerLoop AB';
export const PRODUCT_NAME = 'LedgerLoop AI';
export const WEBSITE_URL = 'https://www.ledgerloop.ai';
export const SUPPORT_EMAIL = 'hello@ledgerloop.ai';

// Public legal pages on the marketing site (ledgerloop-web, src/pages/legal/).
export const LEGAL_URLS = Object.freeze({
  terms: `${WEBSITE_URL}/legal/allmanna-villkor`,
  privacy: `${WEBSITE_URL}/legal/integritetspolicy`,
});

export const copyrightLine = (year = new Date().getFullYear()) => `© ${year} ${COMPANY_LEGAL_NAME}`;
